import { useEffect } from "react";
import { useSelector, connect } from "react-redux";
import PropTypes from "prop-types";
import HeadTabs from "./head-tabs";
import Body from "./body";
import { flagsAndExperimentNames } from "rtr-constants";
import { setTabSelected } from "slices/pdp-slice";

export const TAB_NAMES = {
  reviews: "Reviews",
  product_details: "Product Details",
};

const ProductInfo = props => {
  const reviewCount = useSelector(state => state.reviews?.count);
  const tabSelected = useSelector(state => state.pdp?.tabSelected) || TAB_NAMES.product_details;

  if (props.enableSizeGuide) {
    TAB_NAMES.size_guide = "Size Guide";
  }

  // in the GridProductDrawer, reviews.count is not available at the time of rendering
  // so let's set the tab to reviews if reviews.count is available after the component has mounted
  useEffect(() => {
    if (Number.isInteger(reviewCount) && reviewCount > 0) {
      setTabSelected(TAB_NAMES.reviews);
    }
  }, [reviewCount]);

  const isMobileViewport = useSelector(state => !!state.browser?.isMobileViewport);
  const isBuyNow = useSelector(state => !!state.isBuyNow);
  if (!isMobileViewport) {
    return;
  }

  return (
    <div className="pdp-product-info" data-test-id="pdp-product-info">
      <HeadTabs tabSelected={tabSelected} setTabSelected={setTabSelected} TAB_NAMES={TAB_NAMES} />
      <Body
        isBuyNow={isBuyNow}
        isMobileViewport={isMobileViewport}
        images={props.images}
        imageRotation={props.imageRotation}
        displayName={props.displayName}
        designerDisplayName={props.designerDisplayName}
        productId={props.productId}
        fitNotes={props.fitNotes}
        stylistNotes={props.stylistNotes}
        productDetails={props.productDetails}
        logReadAllReviews={props.logReadAllReviews}
        TAB_NAMES={TAB_NAMES}
        tabSelected={tabSelected}
        enableSizeGuide={props.enableSizeGuide}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    enableSizeGuide: state.flagsAndExperiments?.[flagsAndExperimentNames.CATALOG_SERVICES_ENABLE_SIZE_GUIDE],
  };
};

ProductInfo.propTypes = {
  images: PropTypes.object,
  imageRotation: PropTypes.arrayOf(PropTypes.object),
  displayName: PropTypes.string,
  designerDisplayName: PropTypes.string,
  productId: PropTypes.string,
  fitNotes: PropTypes.string,
  stylistNotes: PropTypes.string,
  productDetails: PropTypes.string,
  logReadAllReviews: PropTypes.func,
  enableSizeGuide: PropTypes.bool,
};

export default connect(mapStateToProps)(ProductInfo);
